module.exports = __webpack_public_path__ + "static/media/icons8-más-filled-1.a1957d0b.svg";